import React, {ReactNode} from 'react';
import {appText} from '../../assets/text/appText';
import './styles.css';

interface Props {
  tip: ReactNode;
  noStandardHeader?: boolean;
}

const TipBox = React.memo(({tip, noStandardHeader = false}: Props) => {
  return (
    <div className="TipBox">
      {!noStandardHeader && (
        <div className="TipHeader">
          <h6>{appText.tapyblTips}</h6>
        </div>
      )}
      <p>{tip}</p>
    </div>
  );
});

export default TipBox;
